const PhoneType = Object.freeze({
  PSTN: "PSTN",
  IP: "IP",
  WORK: "WORK",
});

export default PhoneType;
